import PropTypes from "prop-types";
// import React from "react";
// import IconBoxData from '../../data/iconBox/icon-box.json';
// import IconBox from '../../components/IconBox/IconBox.jsx';
import SectionTitle from "../../components/SectionTitles/SectionTitle";
import NewGif from "../../components/Gif/NewGif";
// import Btn2 from "../../components/Btn/Btn2";

const ServiceIconBox = ({ classOption }) => {
  return (
    <div className={`section section-padding-t50-b80 ${classOption}`}>
      <div className="container">

        <SectionTitle title="ICSI&apos;2026" />
        <div className="row row-cols-1 mb-n6" id="anounce">
          <ul className="li-align">
            <li>
              <h5>
                <div className="font-red" >
                  <a href="./images/backgroud/back2025.jpg">
                    <NewGif />{" "}
                    Welcome to join ICSI&apos;2026 in Chengdu, China, July, 2026!
                  </a>
                </div>
              </h5>
            </li>

          </ul>

        </div>


        <div className='space-50'></div>
        <SectionTitle title="Anouncement" />
        <div className="row row-cols-1 mb-n6" id="anounce">
          <ul className="li-align">


            <li>
              <h5>
                <div className="font-red" >
                  <a href="./gallery">

                  <NewGif />{" "}
                  Congratulations! ICSI&apos;2025 has been held successfully on 11th - 15th, July, 2025!
                  </a>
                </div>
              </h5>
            </li>
            <li>
              <h5>
                <div className="font-red" >
                  <NewGif />{" "}
                  ICSI&apos;2025 has concluded, and the conference proceedings will be published subsequently.
                </div>
              </h5>
            </li>

            <li>
              <h5>
                <div className="font-red" >
                  <NewGif />{" "}
                  On April 30, 2025, notification emails pertaining to each submission were meticulously dispatched to the designated corresponding authors. Simultaneously, the registration portal for both authors and participants has been activated, facilitating seamless access for all interested parties for registration.
                </div>
              </h5>
            </li>
            <li>
              <h5>
                <div className="font-red" >
                  <NewGif />{" "}
                  ICSI 2025 will be held in a hybrid mode, allowing authors to choose freely between attending online or onsite!
                </div>
              </h5>
            </li>


            <br></br>
            {/* <li>
              <h5>
                <div className="font-red" >
                  <a href="./proceeding">
                    <NewGif />{" "}
                    The ICSI&apos;2024 Proceedings (Springer-Nature LNCS 14788 and LNCS 14789) are available online for all participants to download, for free, from August 21, 2024 to September 30, 2024！
                  </a>
                </div>
              </h5>
            </li>
            <li>
              <h5>
                <div className="font-red" >
                  <a href="./program">
                    <NewGif />{" "}
                    The detailed event schedule has been announced！
                  </a>
                </div>
              </h5>
            </li> */}

            <br></br>
            <br></br>

            {/* <li>
              <h5>
                <div className="font-red" >
                  <a href="./images/next/back.jpg">
                    <NewGif />{" "}
                    Welcome to join ICSI&apos;2024 in Xining, Qinghai, China, August 23th-26th, 2024!
                  </a>
                </div>
              </h5>
            </li> */}
            {/* <li>
              <h5>
              <div className="font-red" >
              <a href="./submission">
              {" "}
              <del>
              The deadline for the paper submission has been extended to March 31, 2024!
              </del>
              </a>
              </div>
              </h5>
              </li> */}



            <li>
              <h5>
                <div >
                  <a href="./specialsession#session1">
                    {" "}

                    Special Session 1: &quot;Machine Learning and Swarm Intelligence for Combinatorial Optimization Problem&quot;{" "}
                  </a>
                </div>
              </h5>
            </li>
            <li>
              <h5>
                <div >
                  <a href="./specialsession#session2">

                    Special Session 2: &quot;Large Language Model-Based Swarm Intelligence Optimization Methods&quot;{" "}
                  </a>
                </div>
              </h5>
            </li>
            <li>
              <h5>
                <div >
                  <a href="./specialsession#session3">

                    Special Session 3: &quot;Medical Applications Leveraging Machine Learning in the New Era of Knowledge&quot;{" "}
                  </a>
                </div>
              </h5>
            </li>
            <li>
              <h5>
                <div >
                  <a href="./specialsession#session4">

                    Special Session 4: &quot;Intelligent Computing and Swarm Intelligence in Smart Finance: Theories, Methods, and Practices&quot;{" "}
                  </a>
                </div>
              </h5>
            </li>
            {/* <li>
              <h5>
              <div >
              <a href="./specialsession#session4">
              {" "}
              Special Session 4: &quot;Emerging Trends and Challenges in Multi-Agent Systems: A Comprehensive Analysis and Future Directions&quot;{" "}
              </a>
              </div>
              </h5>
              </li> */}
            {/* <li>
              <h5>
                <div >
                  <a href="./specialsession#session1">
                  {" "}
                    Special Session 1: &quot;Unleashing the Power of Swarms: Exploring Autonomous Decision-Making for Multi-Agent Unmanned Systems&quot;{" "}
                  </a>
                </div>
              </h5>
            </li>
            <li>
              <h5>
                <div >
                  <a href="./specialsession#session2">
                  {" "}
                    Special Session 2: &quot;Data Analysis and Security in Swarm Intelligence&quot;{" "}
                  </a>
                </div>
              </h5>
            </li>
            <li>
              <h5>
                <div >
                  <a href="./specialsession#session3">
                  {" "}
                    Special Session 3: &quot;Research on Swarm Intelligence Optimization Algorithm Based on Large Language Model&quot;{" "}
                  </a>
                </div>
              </h5>
            </li>
            <li>
              <h5>
                <div >
                  <a href="./specialsession#session4">
                  {" "}
                    Special Session 4: &quot;Machine Learning and Swarm Intelligence for Combinatorial Optimization Problem&quot;{" "}
                  </a>
                </div>
              </h5>
            </li>
            <li>
              <h5>
                <div >
                  <a href="./specialsession#session5">
                  {" "}
                    Special Session 5: &quot;Biologically Inspired Intelligence for Mechatronics and Robotics&quot;{" "}
                  </a>
                </div>
              </h5>
            </li> */}
            <br></br>
            <br></br>
            <li>
              <h5>
                <div>

                  <del>
                    Official invitation letters and acceptance notifications will be issued after registration closes. If you need these materials urgently for visa or other purposes, please email us at <a href="mailto:icsi2025@iasei.org">icsi2025@iasei.org</a> to request early issuance. Thank you for your understanding!
                  </del>
                </div>
              </h5>
            </li>
            <li>
              <h5>
                <div>
                  <a href="./callforpaper">
                    {/* <NewGif />{" "} */}
                    <del>
                      ICSI&apos;2025 Call for papers!
                    </del>
                  </a>
                </div>
              </h5>
            </li>
            {/* <li>
              <h5>
                <div className="font-red" >
                  <a href="./submission">
                    <NewGif />{" "}
                    The paper submission deadline has been extended to April 18th, 2025 (Fixed)!
                  </a>
                </div>
              </h5>
            </li> */}


            <br></br>
            <br></br>

            {/* <li>
                <h5>
                <div >
                <a href="./specialsession">
                {" "}
                <del>
                ICSI&apos;2024 Call for Special Session Proposals!
                </del>
                </a>
                </div>
                </h5>
              </li>
            <li>
              <h5>
                <div  >

                    {" "}
                    <del>
                    ICSI&apos;2024 Call for Papers!
                    </del>
                </div>
              </h5>
            </li>
            <li>
              <h5>
                <div >
                    {" "}
                    <del>
                    Author registration is open, please complete the author registration before May 31!
                    </del>
                </div>
              </h5>
            </li>

            <li>
              <h5>
                <div>
                  <a href="./accommodation">
                    <del>
                    As this period coincides with the local peak tourist season, hotel rooms are in short supply, and prices are high during the peak season. To facilitate the efficient and economical participation of delegates for ICSI’2024, our organizing committee has negotiated with the Qinghai Hotel to reserve some rooms for online booking by delegates. The prices are very favorable. Please complete the online booking before July 21st. Otherwise, we cannot guarantee rooms at this contracted price.
                    </del>
                  </a>
                </div>
              </h5>
            </li>
            <li>
              <h5>
                <div >
                  <a href="./accommodation">
                  <del>
                    ICSI’2024将于2024年8月23-26日在青海西宁市的青海宾馆隆重举行。鉴于此时正值当地旅游旺季，各宾馆房间供不应求且价格较高。为了方便各位代表能高效且经济参会，会务组与宾馆经过协商预订了一些房间，供各位参会代表在线预订，价格非常实惠。请大家必须在7月21日之前完成在线预订，逾期预订将无法保证房间及优惠价格。
                  </del>
                  </a>
                </div>
              </h5>
            </li> */}




            {/* <li>
              <h5>
              <div className="font-red" >
              <a href="./gallery">
              <NewGif />{" "}
              Congratulations! ICSI&apos;2023 has been held successfully on 14th - 18th, July! 
              </a>
              </div>
              </h5>
              </li>
            <li>
              <h5>
                <div className="font-red" >
                  <a href="./gallery">
                    <NewGif />{" "}
                    Our wonderful moments!
                  </a>
                </div>
              </h5>
            </li> */}




          </ul>
        </div>
        {/* <div>
        Notice: 
        Due to the rapid overspreading of Omicron variant of COVID-19, even though the ICSI 2022 was planned to be held in a hybrid mode, after carefully evaluating most of announcements and guidance regarding to COVID-19, and too much restrictions on traveling to the venue, released by relevant national departments and Xi&apos;an municipal, the ICSI 2022 organizing committee has made the decision that our ICSI 2022 will continue as scheduled on July 15-19, by being converted to a fully virtual conference. The ICSI 2022 technical team will be providing the ability for the authors with accepted papers to present their work through an interactive online platform or video replay. The presentations of accepted authors will be made available to all registered attendees online.
        </div> */}
        <div className="conference-ind">

          {/* <div className="online-info" >
 Notice: 
Due to the rapid overspreading of Omicron variant of COVID-19, even though the ICSI 2022 was planned to be held in a hybrid mode, after carefully evaluating most of announcements and guidance regarding to COVID-19, and too much restrictions on traveling to the venue, released by relevant national departments and Xi&apos;an municipal, the ICSI 2022 organizing committee has made the decision that our ICSI 2022 will continue as scheduled on July 15-19, by being converted to a fully virtual conference. The ICSI 2022 technical team will be providing the ability for the authors with accepted papers to present their work through an interactive online platform or video replay. The presentations of accepted authors will be made available to all registered attendees online.
</div> */}
        </div>
      </div>
    </div >
  );
};

ServiceIconBox.propTypes = {
  classOption: PropTypes.string,
};
ServiceIconBox.defaultProps = {
  classOption: "section section-padding-t90-b100",
};

export default ServiceIconBox;
